import { useEffect, useRef } from "react";

export const useNavigationBlocker =
    // TODO: Remove the fallback once the page renderer has been deployed the CDN cache has expired
    window.SoftrPageRenderer?.useNavigationBlocker ?? useNavigationBlockerFallback;
function useNavigationBlockerFallback(block: boolean | (() => boolean)) {
    useBeforeUnload((event) => {
        const shouldBlock = typeof block === "function" ? block() : block;
        if (shouldBlock) {
            event.preventDefault();
            // even though it's deprecated, it's still the only way to block navigating away
            event.returnValue = true;
        }
    });
}

function useBeforeUnload(callback: (event: Event) => void) {
    const callbackRef = useRef(callback);
    callbackRef.current = callback;

    useEffect(() => {
        const onBeforeUnload = (event: Event) => callbackRef.current(event);
        window.addEventListener("beforeunload", onBeforeUnload);
        return () => {
            window.removeEventListener("beforeunload", onBeforeUnload);
        };
    }, []);
}
